import { TableHead } from '../ui/table';
import { ArrowUp, ArrowDown, ArrowUpDown } from 'lucide-react';

const collator = new Intl.Collator('fr', { sensitivity: 'base' });
const TEXT_KEYS = new Set(['student_prenom', 'student_nom']);

export const sortResults = (results, { key, dir }) => {
  const sign = dir === 'asc' ? 1 : -1;
  return [...results].sort((a, b) => {
    const va = a[key], vb = b[key];
    if (TEXT_KEYS.has(key)) {
      const ta = va && va !== '?' ? va : null, tb = vb && vb !== '?' ? vb : null;
      if (ta == null && tb == null) return 0;
      if (ta == null) return 1;
      if (tb == null) return -1;
      return sign * collator.compare(ta, tb);
    }
    const na = va == null ? null : key === 'scanned_at' ? new Date(va).getTime() : Number(va);
    const nb = vb == null ? null : key === 'scanned_at' ? new Date(vb).getTime() : Number(vb);
    if (na == null && nb == null) return 0;
    if (na == null) return 1;
    if (nb == null) return -1;
    return sign * (na - nb);
  });
};

export const SortableHead = ({ label, sortKey, sort, onSort }) => {
  const active = sort.key === sortKey;
  const Icon = !active ? ArrowUpDown : sort.dir === 'asc' ? ArrowUp : ArrowDown;
  return (
    <TableHead className="text-xs uppercase tracking-wider text-muted-foreground">
      <button type="button" onClick={() => onSort(sortKey)} className={`inline-flex items-center gap-1 hover:text-foreground transition-colors ${active ? 'text-foreground font-bold' : ''}`}
        data-testid={`sort-${sortKey}`} aria-sort={active ? (sort.dir === 'asc' ? 'ascending' : 'descending') : 'none'}>
        {label} <Icon className={`w-3.5 h-3.5 ${active ? 'text-primary' : 'opacity-50'}`} />
      </button>
    </TableHead>
  );
};
